// eslint-disable-next-line no-unused-vars
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {FaMedal} from 'react-icons/fa';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {getPlayerRankingTop10} from '../../../api/axios';

const TableContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: auto;
  color: #b8b8b8;
  text-align: center;
`;

const StyledTable = styled.table.attrs({className: 'table-striped'})`
  width: 100%;
  border-color: #261d12 !important;
  border-collapse: collapse;
  &.table-striped > tbody > tr:nth-of-type(odd) {
    background-color: rgb(245 64 114 / 12%);
  }
`;

const StyledButton = styled.button``;

const LoadingMessage = styled.div`
  font-size: 1.2rem;
  text-align: center;
`;

const StyledDiv = styled.div.attrs({className: 'text-center mt-3'})``;

const Th = styled.th`
  text-align: left;
`;

const Td = styled.td`
  text-align: left;
`;

const JobIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 5px;
  margin-left: 5px;
`;

const getMedal = rank => {
  if (rank === 1) return <FaMedal style={{color: 'gold'}} />;
  if (rank === 2) return <FaMedal style={{color: 'silver'}} />;
  if (rank === 3) return <FaMedal style={{color: 'brown'}} />;
  return rank;
};

const TopTableSmall = ({server}) => {
  const {t} = useTranslation();
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchRanking = async () => {
    try {
      const response = await getPlayerRankingTop10(server);
      let data = response.data;

      if (typeof data === 'string') {
        console.error('Fehlermeldung von API erhalten:', data);
        setRanking([]); // Leeren Array setzen, um UI-Fehler zu vermeiden
        return;
      }

      // Falls die API-Daten kein Array liefern, in ein Array umwandeln:
      if (!Array.isArray(data)) {
        data = Object.values(data);
      }
      setRanking(data);
      setLoading(false);
    } catch (error) {
      // console.error("Error fetching top ranking:", error);
      setRanking([]); // statt error string im State zu speichern
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchRanking();
    }, 1000); // 1000ms Delay

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] ); // leeres Abhängigkeitsarray, damit es nur einmal beim Mounten ausgeführt wird

  return (
    <TableContainer>
      {loading && ranking.length === 0 ? (
        <LoadingMessage>{t('topTable.loading')}</LoadingMessage>
      ) : (
        <StyledTable as="table">
          <thead>
            <tr>
              <Th>#</Th>
              <Th>{t('topTable.th.name')}</Th>
              <Th>{t('topTable.th.level')}</Th>
            </tr>
          </thead>
          <tbody>
            {ranking.map((player, index) => (
              <tr key={index}>
                <Td>{getMedal(index + 1)}</Td>
                <Td>
                  <JobIcon
                    src={player.job}
                    alt={t('topTable.jobAlt', {job: player.job})}
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = '/assets/jobs/000.jpg';
                    }}
                  />
                  {player.name}
                </Td>
                <Td>{`${player.lv}`}</Td>
              </tr>
            ))}
          </tbody>
        </StyledTable>
      )}
      <StyledDiv>
        <StyledButton onClick={() => navigate('/ranking')}>{t('topTable.showAll')}</StyledButton>
      </StyledDiv>
    </TableContainer>
  );
};

export default TopTableSmall;
